import { fetchData, uploadImage } from "@axios/axios-client";

//Academies Types
export const getAcademiesTypesApi = async () => {
  return fetchData({}, `/academies/types`, "GET");
};

//Academies
export const getAcademiesApi = async () => {
  return fetchData({}, `/academies`, "GET");
};

export const getAcademyApi = async ({ academyId }: { academyId: string }) => {
  return fetchData({}, `/academies/${academyId}`, "GET");
};

export const createAcademyApi = async ({ data }: any) => {
  const { academyTypeId, ...rest } = data;
  return fetchData(
    rest,
    `/academies/types/${academyTypeId}/academies`,
    "POST",
    false,
    true,
  );
};

export const bulkUpdateAcademiesApi = async ({ data }: any) => {
  return fetchData(data, `/academies`, "PUT");
};

export const updateAcademyApi = async ({
  params,
  data,
}: {
  params: { id: string; academyTypeId: string };
  data: any;
}) => {
  return fetchData(
    data,
    `/academies/types/${params.academyTypeId}/academies/${params.id}`,
    "PATCH",
    false,
    true,
  );
};

export const deleteAcademyApi = async ({
  academyTypeId,
  academyId,
}: {
  academyTypeId: string;
  academyId: string;
}) => {
  return fetchData(
    {},
    `/academies/types/${academyTypeId}/academies/${academyId}`,
    "DELETE",
  );
};

// Academy Gallery
export const createAcademyGalleryApi = async ({
  academyId,
  data,
}: {
  academyId: string;
  data: any;
}) => {
  const formData = new FormData();
  data.forEach((file: any) => {
    formData.append("images", file);
  });
  return uploadImage({
    data: formData,
    url: `/academies/${academyId}/gallery`,
    method: "POST",
    contentType: true,
  });
};

export const bulkDeleteAcademyGalleryApi = async ({
  academyId,
  data,
}: {
  academyId: string;
  data: any;
}) => {
  return uploadImage({
    data: { ids: data },
    url: `/academies/${academyId}/gallery`,
    method: "PATCH",
    contentType: false,
  });
};

export const bulkUpdateAcademyGalleryApi = async ({
  academyId,
  data,
}: {
  academyId: string;
  data: any;
}) => {
  return uploadImage({
    data,
    url: `/academies/${academyId}/gallery`,
    method: "PUT",
    contentType: false,
  });
};

// Bookings
export const createBookingApi = async ({ params, data }: any) => {
  await fetchData(data, `/academies/${params.academyId}/bookings`, "POST");
};
export const addMspBookingApi = async ({ params, data }: any) => {
  await fetchData(
    data,
    `/academies/${params.academyId}/msp-bookings/add-booking`,
    "POST",
  );
};

export const cancelAcademyBookingApi = async ({ params, data }: any) => {
  const payload = {
    isCancelled: true,
    cancellationReason: data.reason,
    refundedAmount: data.refundedAmount,
    requestedBy: data.requestedBy,
  };
  await fetchData(
    payload,
    `/academies/${params.academyId}/bookings/${data.bookingId}`,
    "PATCH",
  );
};

export const editAcademyRequestsApi = async ({ params, data }: any) => {
  const academyId = params.academyId ?? params.id;
  await fetchData(data, `/academies/${academyId}/edit/requests`, "POST");
};

export const updateAcademyBookingGroupApi = async ({
  params,
  bookingId,
  data,
}: {
  params: { academyId?: string; id?: string };
  bookingId: string;
  data: {
    newGroupId: string;
    editReason: string;
    requestedBy: string;
  };
}) => {
  const academyId = params.academyId ?? params.id;
  await fetchData(
    data,
    `/academies/${academyId}/bookings/${bookingId}/group`,
    "PATCH",
  );
};

export const extendAcademyBookingApi = async ({ params, data }: any) => {
  await fetchData(
    { expiryDate: data.extendDate },
    `academies/${params.academyId}/bookings/${data.detailedBookingInfo?.id}/extend`,
    "PATCH",
  );
};

export const renewAcademyBookingApi = async ({
  params,
  bookingId,
  data,
}: {
  params: { academyId?: string };
  bookingId: string;
  data: Record<string, unknown>;
}) => {
  return fetchData(
    data,
    `/academies/${params.academyId}/bookings/${bookingId}/renew`,
    "POST",
  );
};

export const renewMspAcademyBookingApi = async ({
  params,
  academiesMspBookingId,
  bookingId,
  data,
}: {
  params: { academyId?: string };
  academiesMspBookingId: string;
  bookingId: string;
  data: Record<string, unknown>;
}) => {
  return fetchData(
    data,
    `academies/${params.academyId}/msp-bookings/${academiesMspBookingId}/bookings/${bookingId}/renew`,
    "POST",
  );
};
